<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path
    d="M8 4H14L18 8V18C18 18.5523 17.5523 19 17 19H8C7.44772 19 7 18.5523 7 18V5C7 4.44772 7.44772 4 8 4Z"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
  <path d="M14 4V8H18" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round" />
</svg>
